import React from 'react';
import { connect } from 'react-redux';
import '@ant-design/compatible/assets/index.css';
import { Layout, Row, Col, Button, Card, message, Modal, Popconfirm } from 'antd';
import { EmptyState } from '../empty_state/EmptyState';
import {
	addNewSupplierForBuyers,
	fetchSuppliersForBuyers,
	inviteSupplierUserFromBuyer,
} from '../../thunks/supplier_private_networks_thunks';
import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';
import { AddressDisplay } from '../address_display/AddressDisplay';
import { capitalizeEachWord } from '../../utils/DataFormatterUtils';
import { nullSafeGet, nullSafeGetOrElse, stopDefaultEvents } from '../../utils/DataAccessUtils';
import SupplierPrivateNetworkCreateForm from '../supplier_private_network_create_form/SupplierPrivateNetworkCreateForm';

import SelectSupplierCard from '../select_supplier_card_display/SelectSupplierCard';
import { withRouter } from 'react-router';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { isInternalTech, PERMISSION_NAMES } from '../../utils/AuthUtils';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import {
	ContractorPrivateNetworksRestCrudThunksForBuyer,
	ContractorPrivateNetworksRestCrudThunksForSupplier,
	deleteSupplierSupplierRelationshipBySupplierFacilityId,
} from '../../thunks/contractors_private_networks_thunks';
import InviteContractorForm from '../invite_contractor_form/InviteContractorForm';
import { ROLE_TYPES } from '../../utils/DataConstants';

const { Content } = Layout;
require('./ContractorPrivateNetworkIndexPage.less');

const CONTRACTOR_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION = 'contractorPrivateNetworksIndex';
const SUPPLIER_PRIVATE_NETWORKS_SEARCH_TARGET_COLLECTION = 'supplierPrivateNetworksSearch';

class ContractorPrivateNetworkIndexPage extends React.Component<any, any> {
	initialPagination: any = { current: 1, pageSize: 10 };
	initialFilters: any = {};
	formRefs: any;

	constructor(props) {
		super(props);
		this.formRefs = {};
		this.state = {
			supplierPrivateNetworkCreateFormVisible: false,
			supplierPrivateNetworkEditFormVisible: false,
			supplierFacilityId: undefined,
			supplierFacility: null,
			infoModalVisible: false,
			selectSupplierModalVisible: false,

			selectSuppliers: [],
			supplierInfo: {},

			creatingPrivateNetwork: false,
			removingFacilityId: null,
		};
	}

	componentDidMount() {}

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	handleSupplierPrivateNetworkCreateSubmit = () => {
		const { createContractorPrivateNetwork, currentUser, inviteSupplierUser } = this.props;
		const { supplierInfo } = this.state;
		const form = this.formRefs['supplierPrivateNetworkCreateForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			this.setState({ creatingPrivateNetwork: true });

			createContractorPrivateNetwork({
				...supplierInfo,
				supplierFacilityId: values.supplierFacilityId,
			})
				.then(() => {
					this.setState({
						supplierPrivateNetworkCreateFormVisible: false,
						infoModalVisible: false,
						selectSupplierModalVisible: false,
					});
					this.refreshSupplierPrivateNetwork();
					if (supplierInfo.primaryContactEmail) {
						inviteSupplierUser(
							values.supplierFacilityId,
							currentUser.email,
							supplierInfo.primaryContactEmail,
							supplierInfo.primaryContactFirstName,
							supplierInfo.primaryContactLastName
						).then(() => {
							message.success(
								`${supplierInfo.primaryContactFirstName} ${supplierInfo.primaryContactLastName} has been sent an invite to join OpenWrench at the email address: ${supplierInfo.primaryContactEmail}`
							);
						});
					}
				})
				.finally(() => this.setState({ creatingPrivateNetwork: false }));
		});
	};

	handleSupplierPrivateNetworkCreateCancel = (e) => {
		this.setState({
			supplierPrivateNetworkCreateFormVisible: false,
		});
		const form = this.formRefs['supplierPrivateNetworkCreateForm'].props.form;
		form.resetFields();
	};

	refreshSupplierPrivateNetwork = () => {
		const { fetchContractorPrivateNetwork, supplierPrivateNetworks } = this.props;
		fetchContractorPrivateNetwork(
			null,
			CONTRACTOR_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION,
			this.initialPagination,
			nullSafeGetOrElse('supplierPrivateNetworksIndex.sorting', supplierPrivateNetworks, {}),
			nullSafeGetOrElse('supplierPrivateNetworksIndex.filters', supplierPrivateNetworks, {})
		);
	};

	handleSupplierPrivateNetworkEditCancel = (e) => {
		this.setState({
			supplierPrivateNetworkEditFormVisible: false,
			supplierFacilityId: null,
			supplierFacility: null,
		});
	};

	showInfoModal = (record) => {
		this.setState({ infoModalVisible: true });
	};
	handleCloseInfoModal = () => {
		this.setState({ infoModalVisible: false });
	};

	submitNewSupplierInfo = (supplier) => {
		const { fetchSuppliers } = this.props;
		this.setState({ supplierInfo: supplier }, () => {
			if (supplier.primaryContactEmail) {
				Promise.all([
					fetchSuppliers(
						supplier.name,
						supplier.primaryContactEmail,
						SUPPLIER_PRIVATE_NETWORKS_SEARCH_TARGET_COLLECTION
					),
				]).then(() => {
					const { supplierPrivateNetworks } = this.props;
					if (nullSafeGetOrElse('searchRecords.records', supplierPrivateNetworks, []).length > 0) {
						this.setState({
							selectSuppliers: supplierPrivateNetworks.searchRecords.records,
							selectSupplierModalVisible: true,
						});
					} else {
						this.handleAddNewSupplier();
					}
				});
			} else {
				// Supplier name and email not provided. so adding self managed supplier
				this.handleAddNewSupplier();
			}
		});
	};

	handleAddNewSupplier = () => {
		const { addNewSupplier } = this.props;
		const { supplierInfo } = this.state;
		addNewSupplier(supplierInfo).then((record) => {
			this.setState({ supplierFacilityId: record.id }, () => {
				this.handleSupplierSelected(record);
			});
		});
	};

	handleBackSelectSupplierModal = () => {
		this.setState({ selectSupplierModalVisible: false, infoModalVisible: true });
	};

	handleCloseSelectSupplierModal = () => {
		this.setState({ selectSupplierModalVisible: false, infoModalVisible: false });
	};

	handleSupplierSelected = (record) => {
		const { createContractorPrivateNetwork, inviteSupplierUser, currentUser } = this.props;
		const { supplierInfo } = this.state;
		this.setState({ creatingPrivateNetwork: true });

		// const allSNs = getAllSupplierPrivateNetworkEntities(values);

		createContractorPrivateNetwork({
			...supplierInfo,
			supplierFacilityId: record.id,
		})
			.then(() => {
				this.setState({
					supplierPrivateNetworkCreateFormVisible: false,
					infoModalVisible: false,
					selectSupplierModalVisible: false,
				});
				this.refreshSupplierPrivateNetwork();
				if (record.primaryContactEmail) {
					inviteSupplierUser(
						record.id,
						currentUser.email,
						supplierInfo.primaryContactEmail,
						supplierInfo.primaryContactFirstName,
						supplierInfo.primaryContactLastName
					).then(() => {
						message.success(
							`${supplierInfo.primaryContactFirstName} ${supplierInfo.primaryContactLastName} has been sent an invite to join OpenWrench at the email address: ${supplierInfo.primaryContactEmail}`
						);
					});
				}
			})
			.finally(() =>
				this.setState({ creatingPrivateNetwork: false, selectSupplierModalVisible: false })
			);
	};

	handleExistingSupplierSelected = (record) => {
		this.setState({ selectSupplierModalVisible: false, infoModalVisible: false });
	};

	removeFromSupplierPrivateNetwork = (supplierFacilityId) => {
		const { deleteSupplierSupplierRelationship } = this.props;

		this.setState({ removingFacilityId: supplierFacilityId });
		deleteSupplierSupplierRelationship(supplierFacilityId)
			.then(() => {
				this.refreshSupplierPrivateNetwork();
				message.success(`Deleted subcontractor from your private network.`);
			})
			.catch(message.error)
			.finally(() => this.setState({ removingFacilityId: null }));
	};

	render() {
		const { supplierPrivateNetworks, location, history, userType, contractorPrivateNetworks } =
			this.props;
		const onRow = (record) => ({
			onClick: () => {
				let searchString = location.search;
				if (searchString[0] === '?') {
					searchString = searchString.slice(1);
				}
				let backUrl = `/${userType}/contractors/detail/${record.supplierFacility.id}`;
				if (searchString && searchString.length > 0) {
					backUrl = backUrl.concat(`?backlinkParams=${encodeURIComponent(searchString)}`);
				}
				history.push(backUrl);
			},
		});
		const columns = [
			{
				title: 'Name',
				dataIndex: 'name',
				render: (text, record) => {
					const spendCategories = nullSafeGetOrElse(
						'supplierFacility.categoryNames',
						record,
						''
					).split(',');
					return (
						<div style={{ display: 'flex', alignItems: 'center', minWidth: 320 }}>
							<div style={{ marginRight: 16 }}>
								{nullSafeGet('supplierFacility.logoURL', record) ? (
									<FlexibleImageAvatar
										displayName={text}
										showPopover={false}
										popoverText={text}
										squareMode={true}
										width="120px"
										height="80px"
										imageUrl={nullSafeGet('supplierFacility.logoURL', record)}
									/>
								) : (
									<FlexibleImageAvatar
										displayName={
											nullSafeGet('supplierFacilityAlias', record) ||
											nullSafeGet('supplierFacility.name', record)
										}
										showPopover={false}
										popoverText={
											nullSafeGet('supplierFacilityAlias', record) ||
											nullSafeGet('supplierFacility.name', record)
										}
										squareMode={true}
										width="120px"
										height="80px"
										imageUrl="https://s3.amazonaws.com/emptor-data-assets/images/empty-state/icons8-city-filled-100.png"
									/>
								)}
							</div>
							<div>
								<div
									style={{
										fontSize: 18,
										wordBreak: 'break-word',
									}}
								>
									{nullSafeGet('supplierFacilityAlias', record) ||
										nullSafeGet('supplierFacility.name', record)}
								</div>
								<div style={{ marginBottom: 0, fontSize: 14 }}>
									{record.relationshipStatus && (
										<div
											className={`text-base capitalize text-gray-500 ${
												record.relationshipStatus === 'connected' ? 'text-green-500' : ''
											}`}
										>
											{record.relationshipStatus === 'SelfManaged'
												? 'Self Managed'
												: record.relationshipStatus}
										</div>
									)}
									<div
										style={{ wordBreak: 'normal', whiteSpace: 'normal', color: 'rgba(0,0,0,0.45)' }}
									>
										{spendCategories
											.map((categoryName) => capitalizeEachWord(categoryName))
											.slice(0, 2)
											.join(', ')}
										{spendCategories.length > 3 ? ' and more' : null}
									</div>
								</div>
								<AddressDisplay
									hidePostcode={true}
									hideCountry={true}
									hideStreetAddress={true}
									address={record.primaryAddress}
									style={{
										color: 'rgba(0,0,0,0.45)',
									}}
								/>
							</div>
						</div>
					);
				},
			},
			{
				title: 'Locations Served',
				dataIndex: 'locationNames',
				render: (text, record) => <div></div>,
			},
			{
				title: 'Delete Actions',
				dataIndex: 'supplierFacilityId',
				render: (text, record) => (
					<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_SUPPLIERS}>
						<Popconfirm
							title={'Are you sure, you want remove this subcontractor?'}
							onConfirm={(e) => {
								stopDefaultEvents(e);
								this.removeFromSupplierPrivateNetwork(record.supplierFacilityId);
							}}
							onCancel={(e) => stopDefaultEvents(e)}
							okText="Yes"
						>
							<Button
								loading={this.state.removingFacilityId === record.supplierFacilityId}
								danger
								ghost
								onClick={(e) => stopDefaultEvents(e)}
							>
								Remove Subcontractor
							</Button>
						</Popconfirm>
					</AccessPermissionChecker>
				),
			},
		];

		return (
			<Content className="contractorsprivateNetworkIndexPage" style={{ padding: '0 0.5em' }}>
				<SupplierPrivateNetworkCreateForm
					userType={userType}
					wrappedComponentRef={this.saveFormRef('supplierPrivateNetworkCreateForm')}
					visible={this.state.supplierPrivateNetworkCreateFormVisible}
					supplierFacilityId={this.state.supplierFacilityId}
					supplierFacility={this.state.supplierFacility}
					onCancel={this.handleSupplierPrivateNetworkCreateCancel}
					onSubmit={this.handleSupplierPrivateNetworkCreateSubmit}
					loading={this.state.creatingPrivateNetwork}
				/>

				<Modal
					//Select Supplier Modal
					width={800}
					title={
						<div style={{ width: '100%', position: 'relative', display: 'block' }}>
							<span>
								{this.state.selectSuppliers.length > 1
									? 'Did you mean any of the following Suppliers?'
									: 'Did you mean this Supplier?'}
							</span>
						</div>
					}
					footer={
						<div style={{ display: 'block', position: 'relative', width: '100%', height: '32px' }}>
							<div
								style={{
									display: 'inline-block',
									position: 'absolute',
									left: '0px',
									top: '0px',
									verticalAlign: 'bottom',
								}}
							>
								<Button onClick={this.handleBackSelectSupplierModal}>Back</Button>
							</div>
							<div
								style={{
									display: 'inline-block',
									position: 'absolute',
									right: '0px',
									top: '0px',
									verticalAlign: 'bottom',
								}}
							>
								<Button
									onClick={() => {
										this.handleAddNewSupplier();
										this.handleCloseSelectSupplierModal();
									}}
									type="primary"
								>
									No, Invite My Supplier
								</Button>
							</div>
						</div>
					}
					bodyStyle={{ overflowY: 'scroll' }}
					closable={false}
					onCancel={this.handleCloseInfoModal}
					visible={this.state.selectSupplierModalVisible}
					destroyOnClose={true}
				>
					<div
						style={{
							display: 'block',
							position: 'relative',
							width: '100%',
							height: '560px',
							borderRadius: '5px',
							padding: '4px 6px 4px 4px',
						}}
					>
						{this.state.selectSuppliers.map((supplier, i) => (
							<SelectSupplierCard
								supplier={supplier}
								currentSuppliers={supplierPrivateNetworks}
								key={i}
								handleSupplierSelected={() => {
									this.setState({ supplierFacilityId: supplier.id });
									this.handleSupplierSelected(supplier);
								}}
								handleExistingSupplierSelected={() => {
									this.setState({ supplierFacilityId: supplier.id });
									supplier.supplierFacilityId = supplier.id;
									this.handleExistingSupplierSelected(supplier);
								}}
							/>
						))}
						<div
							style={{
								display: 'none',
								position: 'relative',
								width: '100%',
								padding: '10px',
								textAlign: 'center',
							}}
						>
							<Button
								onClick={() => {
									this.handleAddNewSupplier();
									this.handleCloseSelectSupplierModal();
								}}
							>
								No, Invite My Supplier
							</Button>
						</div>
					</div>
				</Modal>

				<Modal
					//Supplier Contact info modal
					width={640}
					title={<span>Add Subcontractor</span>}
					footer={null}
					closable={false}
					onCancel={this.handleCloseInfoModal}
					visible={this.state.infoModalVisible}
					destroyOnClose={true}
				>
					<InviteContractorForm
						submit={this.submitNewSupplierInfo}
						cancel={this.handleCloseInfoModal}
					/>
				</Modal>

				<Row style={{ margin: '0.5em 0px ' }}>
					<Col span={24}>
						<Card bodyStyle={{ padding: 8 }}>
							<ReduxDataTable
								filterConfig={[]}
								handleQueryParams
								emptyState={
									<EmptyState
										graphic={
											<img
												style={{ marginBottom: 8 }}
												src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
												alt="It's a little lonely in here."
											/>
										}
										headline={"It's a little lonely in here."}
										body={
											<div style={{ textAlign: 'center' }}>
												<div style={{ maxWidth: 440, marginBottom: 16 }}>
													Looks like your team has not added any supplier in your private network
													yet.
												</div>
											</div>
										}
									/>
								}
								entityCollectionName="contractor_private_networks"
								stateSlice={contractorPrivateNetworks}
								showHeader={false}
								targetCollectionName={CONTRACTOR_PRIVATE_NETWORKS_INDEX_TARGET_COLLECTION}
								tableColumns={columns}
								onTableRow={onRow}
								keyAccessor={(el) => el.supplierFacilityId}
								fetchData={
									userType === ROLE_TYPES.SUPPLIER
										? ContractorPrivateNetworksRestCrudThunksForSupplier
										: ContractorPrivateNetworksRestCrudThunksForBuyer
								}
								rightActions={
									<div className="flex flex-row items-center">
										<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_SUPPLIERS}>
											<Button
												size="large"
												type="primary"
												onClick={this.showInfoModal}
												className="inline-block-visible-md"
											>
												Add Subcontractor
											</Button>
										</AccessPermissionChecker>
									</div>
								}
							/>
						</Card>
					</Col>
				</Row>
			</Content>
		);
	}
}

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
	problemTypes: state.problem_types,
	locations: state.locations,
	supplierPrivateNetworks: state.supplier_private_networks,
	contractorPrivateNetworks: state.contractor_private_networks,
	selectSuppliers: state.selectSuppliers,
	userType: (state as any).session.userType,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	createContractorPrivateNetwork: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? ContractorPrivateNetworksRestCrudThunksForSupplier.create(entity)
				: ContractorPrivateNetworksRestCrudThunksForBuyer.create(entity)
		),

	fetchSuppliers: (name, email, targetCollectionName) =>
		dispatch(
			fetchSuppliersForBuyers(ownProps.userType)(name, email)('supplierPrivateNetworksSearch')
		),
	addNewSupplier: (entity) => dispatch(addNewSupplierForBuyers(ownProps.userType)(entity)),

	fetchContractorPrivateNetwork: (
		additionalParams,
		targetCollectionName,
		pagination,
		sorting,
		filters
	) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? ContractorPrivateNetworksRestCrudThunksForSupplier.read(
						additionalParams,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
				: ContractorPrivateNetworksRestCrudThunksForBuyer.read(
						additionalParams,
						targetCollectionName,
						pagination,
						sorting,
						filters
				  )
		),
	inviteSupplierUser: (supplierFacilityId, fromEmail, toEmail, firstName, lastName) =>
		dispatch(
			inviteSupplierUserFromBuyer(ownProps.userType)(
				supplierFacilityId,
				fromEmail,
				toEmail,
				firstName,
				lastName
			)
		),
	deleteSupplierSupplierRelationship: (id) =>
		dispatch(deleteSupplierSupplierRelationshipBySupplierFacilityId(ownProps.userType)(id)),
});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ContractorPrivateNetworkIndexPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
